export const AEROCIVIL_CALIBRATION_VERSION = "1.0.0";

export const AEROCIVIL_CALIBRATION_REFERENCE_POINTS = [
  { id: "bogota", label: "Bogotá", lng: -74.0721, lat: 4.711 },
  { id: "medellin", label: "Medellín", lng: -75.5636, lat: 6.2518 },
  { id: "cartagena", label: "Cartagena", lng: -75.4794, lat: 10.391 },
];

export const AEROCIVIL_CALIBRATION_QA_CHECKLIST = [
  "Radar image footprint plausible for selected site (GTA / CRM / ADZ)",
  "Bogotá / Medellín / regional context points fall inside overlay when expected",
  "Overlay does not silently cover unrelated continents",
  "Honest unavailable state when cache is empty",
  "Valley Preferred chain unchanged with Aerocivil enabled",
  "Mobile layers panel toggle works",
];

export const AEROCIVIL_OUTREACH_STATUS_OPTIONS = [
  { value: "not_sent", label: "Not sent" },
  { value: "sent", label: "Sent" },
  { value: "response_pending", label: "Response pending" },
  { value: "provisional_confirmed", label: "Provisional confirmed" },
  { value: "confirmed", label: "Confirmed" },
  { value: "declined", label: "Declined" },
];
